export default {
  // 页面标题
  'adsReport.title': '数据报表分析',

  // 搜索字段
  'adsReport.agentName': '代理名称',
  'adsReport.agentAccount': '代理名称',
  'adsReport.adsPlatform': '归因平台',
  'adsReport.adsName': '归因名称',
  'adsReport.eventName': '归因事件',
  'adsReport.dateRange': '日期范围',

  // 按钮
  'adsReport.search': '查询',
  'adsReport.reset': '重置',
  'adsReport.export': '导出',

  // 表格列
  'adsReport.serial': '序号',
  'adsReport.date': '日期',
  'adsReport.uploadCount': '上传量',
  'adsReport.successCount': '成功量',

  // 消息提示
  'adsReport.fetchDataFailed': '获取数据失败',
  'adsReport.noData': '暂无数据',
  'adsReport.exportSuccess': '导出任务已提交，请在下载列表中查看',
  'adsReport.exportFailed': '导出失败',

  // 分页
  'adsReport.totalRecords': '共 {total} 条记录',
  'adsReport.pagination': '第 {current} 页，共 {page} 页，总计 {total} 条记录',
};
